import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "patient_portal";

  constructor(private router: Router) {
    void this.handleStripeRedirect();
  }

  private async handleStripeRedirect(): Promise<void> {
    const searchParams = new URLSearchParams(window.location.search);
    const paymentIntentId = searchParams.get("payment_intent");
    if (!paymentIntentId) {
      return;
    }

    const token = searchParams.get("token");
    const paymentReturnRoute = token ? "/pay/payment-return" : "/billing/payment-return";

    const navigationSucceeded = await this.router
      .navigate([paymentReturnRoute], {
        queryParams: {
          payment_intent: paymentIntentId,
          payment_intent_client_secret:
            searchParams.get("payment_intent_client_secret") || "",
          redirect_status: searchParams.get("redirect_status") || "",
          patientId: searchParams.get("patientId") || "",
          patientName: searchParams.get("patientName") || "",
          token: token || "",
        },
      })
      .catch(() => false);

    if (navigationSucceeded) {
      window.history.replaceState(
        {},
        "",
        window.location.pathname + window.location.hash,
      );
    }
  }
}
